import { useIsTrialing } from '@/modules/account'
import { useProject } from '@/modules/projects/hooks'
import { TrialNextSteps } from './TrialNextSteps'

export const TrialCaseDetails = ({ slug }: { slug: string }) => {
  const isTrialing = useIsTrialing()
  const project = useProject()

  if (!isTrialing || !project?.firstProcessedAt) return null

  return (
    <div className="mt-6 border-t pt-5">
      <TrialNextSteps slug={slug} />
    </div>
  )
}
